export enum KeyTypesPix {
  EVP = 'Chave aleatória',
  CNPJ = 'CNPJ',
}
